import FieldTestPurchase from './FieldTestPurchase';

export default FieldTestPurchase;


// WEBPACK FOOTER //
// ./src/components/FieldTestPurchase/index.jsx